import { Box, Button, Text } from '@stitch-fix/mode-react';
import { MODE_LEGACY_MIN_WIDTH } from '../../utils/values/mediaQueries';
import type { CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import styles from './style.module.scss';

export type CareersHeroProps = {
  title: string;
  subtitle: string;
  cta: {
    text: string;
    href: string;
  };
  desktopImage: Pick<CloudinaryImageFields, 'alt' | 'src' | 'cloudinaryAsset'>;
  mobileImage: Pick<CloudinaryImageFields, 'alt' | 'src' | 'cloudinaryAsset'>;
};

export const CareersHero = ({
  title,
  subtitle,
  cta,
  desktopImage,
  mobileImage,
}: CareersHeroProps) => (
  <Box
    maxWidth={{ sm: '375px', md: '768px', lg: '100%' }}
    mx="auto"
    pt={{ lg: 7.5 }}
    pb={{ lg: 12 }}
    className={styles.container}
  >
    <Box
      mx="auto"
      px={{ sm: 1.5, lg: 1 }}
      py={{ sm: 2, lg: 2.5 }}
      bgColor="white"
      maxWidth={{ lg: '540px' }}
    >
      <Text setting="title-xlarge" as="h1" mb={0.5}>
        {title}
      </Text>
      <Text setting="subtitle-small" mb={1}>
        {subtitle}
      </Text>
      <Button as="a" href={cta.href}>
        {cta.text}
      </Button>
    </Box>
    <div className={styles['background-image']}>
      <CloudinaryPicture
        alt={mobileImage.alt}
        sources={[
          {
            minWidth: 0,
            cloudinaryAsset: mobileImage.cloudinaryAsset,
            sizes: [
              { minWidth: 0, fluidWidth: 100 },
              { minWidth: 375, staticWidth: 375 },
              {
                minWidth: MODE_LEGACY_MIN_WIDTH.sm,
                staticWidth: MODE_LEGACY_MIN_WIDTH.sm,
              },
            ],
          },
          {
            minWidth: 1024,
            cloudinaryAsset: desktopImage.cloudinaryAsset,
            sizes: [{ minWidth: 1024, fluidWidth: 100 }],
          },
        ]}
        imageProps={{
          // width and height are overriden in the CSS
          style: { width: undefined, height: undefined },
        }}
      />
    </div>
  </Box>
);
